const types = {
  GET_OPTIONS_START: 'GET_OPTIONS_START',
  GET_OPTIONS_SUCCESS: 'GET_OPTIONS_SUCCESS',
  GET_OPTIONS_FAILURE: 'GET_OPTIONS_FAILURE',
  GET_COLLECTION_FRAMES_SUCCESS: 'GET_COLLECTION_FRAMES_SUCCESS',
  GET_FRAME_DETAILS_SUCCESS: 'GET_FRAME_DETAILS_SUCCESS',
  GET_FRAME_OPTIONS_SUCCESS: 'GET_FRAME_OPTIONS_SUCCESS',
  GET_FRAME_SIZES_SUCCESS: 'GET_FRAME_SIZES_SUCCESS',
  GET_FRAME_COLORS_SUCCESS: 'GET_FRAME_COLORS_SUCCESS',
  GET_OPTION_DISPLAYS_SUCCESS: 'GET_OPTION_DISPLAYS_SUCCESS',
  GET_COLLAGE_PREVIEW_IMAGES_START: 'GET_COLLAGE_PREVIEW_IMAGES_START',
  GET_COLLAGE_PREVIEW_IMAGES_SUCCESS: 'GET_COLLAGE_PREVIEW_IMAGES_SUCCESS',
  GET_COLLAGE_PREVIEW_IMAGES_FAILURE: 'GET_COLLAGE_PREVIEW_IMAGES_FAILURE',
  POST_COLLAGE_PREVIEW_IMAGES_START: 'PUT_COLLAGE_PREVIEW_IMAGES_START',
  POST_COLLAGE_PREVIEW_IMAGES_SUCCESS: 'PUT_COLLAGE_PREVIEW_IMAGES_SUCCESS',
  POST_COLLAGE_PREVIEW_IMAGES_FAILURE: 'PUT_COLLAGE_PREVIEW_IMAGES_FAILURE',
  DELETE_COLLAGE_PREVIEW_IMAGE_START: 'DELETE_COLLAGE_PREVIEW_IMAGE_START',
  DELETE_COLLAGE_PREVIEW_IMAGE_SUCCESS: 'DELETE_COLLAGE_PREVIEW_IMAGE_SUCCESS',
  DELETE_COLLAGE_PREVIEW_IMAGE_FAILURE: 'DELETE_COLLAGE_PREVIEW_IMAGE_FAILURE',
  // Custom Size Settings
  GET_CUSTOM_SIZE_SETTINGS_SUCCESS: 'GET_CUSTOM_SIZE_SETTINGS_SUCCESS',
};
export default types;
